export default __webpack_public_path__ + "static/media/1174.56ac6625.png";